$(function (){
    /* set width of image absolute */
    $(window).on('resize', function() {
        var getWidthScreen = window.innerWidth;
        if (window.innerWidth <= 768) {
            $('.info-map img').css("width", getWidthScreen);
        } else{
            $('.info-map img').css("width", "");
        }
    });
    var getWidthScreen = window.innerWidth;
    if (window.innerWidth <= 768) {
        $('.info-map img').css("width", getWidthScreen);
    } else{
        $('.info-map img').css("width", "");
    }
});